import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingService, AlertService } from 'ngx-kuv-tools';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { TipoRevisionService } from '../../tipo-revision/tipo-revision.service';
import { UsuarioService } from '../../usuario/usuario.service';
import { VehiculoService } from '../../vehiculo/vehiculo.service';
import { RevisionService } from '../revision.service';
import { ModalDeleteComponent } from 'src/app/utils/modal-delete/modal-delete.component';
import { Router } from '@angular/router';
import { ProductoService } from '../../producto/producto.service';
import { TipoRevisionCreateComponent } from '../../tipo-revision/tipo-revision-create/tipo-revision-create.component';
import { VehiculoCreateComponent } from '../../vehiculo/vehiculo-create/vehiculo-create.component';
import { UsuarioCreateComponent } from '../../usuario/usuario-create/usuario-create.component';

@Component({
  selector: 'app-revision-create',
  templateUrl: './revision-create.component.html',
  styleUrls: ['./revision-create.component.scss']
})
export class RevisionCreateComponent implements OnInit {

  encargados: any[] = [];
  productos: any[] = [];
  lineas: any[] = [];
  form: FormGroup = new FormGroup({});
  vehiculos: any[] = [];
  usuarios: any[] = [];
  tipo_aceites: any[] = [];
  tipos: any[] = [];

  get total() { return this.lineas.map(e => e.precio_unitario * e.cantidad).reduce((t,e) => t+e, 0) }

  constructor(
    public formBuilder: FormBuilder,
    private loading: LoadingService,
    private alerts: AlertService,
    // public activeModal: NgbActiveModal,
    public service: RevisionService,
    public formatter: FormatterService,
    private modalService: NgbModal,
    private usuarioService: UsuarioService,
    private vehiculoService: VehiculoService,
    private productoService: ProductoService,
    private router: Router,
    private tipoService: TipoRevisionService,
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      tipo_revision_id: [null, [Validators.required]],
      fecha: [null, [Validators.required]],
      kilometraje: [null, [Validators.required]],
      proxima_revision: [null, [Validators.required]],
      fecha_estimada: [null],
      encargado: [null],
      encargado_id: [null, [Validators.required]],
      vehiculo_id: [null, [Validators.required]],
      detalle: [null, []],
    });

    this.form.patchValue({fecha: new Date().toISOString().substring(0, 10)})

    this.getTiposServicio();
    this.getVehiculos();
    this.cargarProductos();
    this.cargarEncargados();
  }

  cargarEncargados(asignarUltimo: boolean = false){
    this.loading.show()
    this.usuarioService.select().subscribe({
      next: (res: any) => {
        this.loading.hide();
        this.encargados = res.filter((e: any) => e.rol_id != 4);
        if(asignarUltimo && this.encargados.length > 0) this.form.patchValue({encargado_id: this.encargados[this.encargados.length -1].id});
      }, error: (err: any) => {
        this.loading.hide();
        if(err.response) this.alerts.addAlert(err.response, 'danger');
      }
    });
  }

  agregarEncargado(){
    const modalRef = this.modalService.open(UsuarioCreateComponent,{ size: 'lg', scrollable: true });
    modalRef.result.then((result: any) => {
      this.cargarEncargados(true);
    }, (reason: any) => {});
  }

  searchFnEncargado(term: any, item: any) {
    const removeAccents = (str: any) => {
      return str.normalize("NFD").replace(/[̀-ͯ]/g, "");
    }
    let terms = removeAccents(term.toLowerCase()).split(' ');
    let result = true;
    let p = removeAccents(([item.nombre, item.apellido].join(' ')).toLowerCase());
    terms.forEach((t: any) => {
      result = result && p.includes(t);
    });
    return result;
  }

  cargarProductos(){
    this.loading.show()
    this.productoService.select().subscribe({
      next: (res: any) => {
        this.loading.hide();
        this.productos = res.map((e: any) => {
          e.tipo = e.tipo == 1 ? 'Producto' : 'Servicio'
          return e;
        });
      }, error: (err: any) => {
        this.loading.hide();
        if(err.response) this.alerts.addAlert(err.response, 'danger');
      }
    });
  }

  searchFnProducto(term: any, item: any) {
    const removeAccents = (str: any) => {
      return str.normalize("NFD").replace(/[̀-ͯ]/g, "");
    }
    let terms = removeAccents(term.toLowerCase()).split(' ');
    let result = true;
    let p = removeAccents(([item.nombre, item.codigo_barra, item.sku].join(' ')).toLowerCase());
    terms.forEach((t: any) => {
      result = result && p.includes(t);
    });
    return result;
  }

  agregarProducto(){
    let aux = this.lineas.slice(0)
    aux.push({
      producto_id: null,
      cantidad: 1,
      precio_unitario: 0
    });
    this.lineas = aux;
  }

  quitarProducto(index: number){
    let aux = this.lineas.slice(0);
    aux.splice(index,1);
    this.lineas = aux;
  }

  productoCambiado(ev: any, index: number){
    if(ev){
      let aux = this.lineas.slice(0);
      aux[index].precio_unitario = ev.precio_venta ?? 0;
      this.lineas = aux;
    }
  }

  agregarConcepto(){
    const modalRef = this.modalService.open(TipoRevisionCreateComponent,{ size: 'lg', centered: true });
    modalRef.result.then((result: any) => {
      this.getTiposServicio(true);
    }, (reason: any) => {});
  }
  agregarVehiculo(){
    const modalRef = this.modalService.open(VehiculoCreateComponent, { size: 'lg', scrollable: true });
    modalRef.result.then((result: any) => {
      this.getVehiculos(true);
    }, (reason: any) => { });
  }

  guardar(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.alerts.addAlert("Hay errores en el formulario.", "warning");
      return;
    }

    if(this.lineas.map(element => !element.producto_id).reduce((t,e) => t || e, false)){
      this.alerts.addAlert("Hay algunos productos o servicios que no se han seleccionado.", "warning");
      return;
    }

    this.loading.show();
    let data = Object.assign({}, this.form.value);
    data.lineas = this.lineas;
    this.service.insert(data).subscribe({
      next: (res) => {
        this.descargar(res);
        this.loading.hide();
        this.router.navigate(['revisiones/index']);
        // this.activeModal.close(res.model);
        this.alerts.addAlert("Vehículo registrado con éxito.", "success");
      },
      error: (err) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("No se pudo guardar el registro de vehículo.", "danger");
        if (err.error.msg) {
          this.alerts.addAlert(err.error.msg, "danger");
        }
        if (err.error.errors[0]) {
          this.alerts.addAlert(err.error.errors[0].msg, "danger");
        }
      }
    });
  }

  descargar(element: any) {
    this.loading.show();
    this.service.downloadPdf(element).subscribe({
      next: (res: any) => {
        this.loading.hide();
        let downloadURL = window.URL.createObjectURL(res);
        let link = document.createElement('a');
        link.href = downloadURL;
        link.download = `Orden de Trabajo N°${element.id}.pdf`;
        link.click();
      }, error: (err: any) => {
        this.loading.hide();
        this.alerts.addAlert('No se pudo descargar el documento.', 'danger');
      }
    });
  }

  cantidadCambiada(item: any){
    if(!item.cantidad) item.cantidad = 1;
  }

  valorCambiado(item: any){
    if (!item.precio_unitario) item.precio_unitario = 0;
  }

  getVehiculos(setLastTipoAsActive: boolean = false): void {
    this.loading.show();
    this.vehiculoService.index_select().subscribe({
      next: (res) => {
        this.loading.hide();
        this.vehiculos = res;
        if (!this.form.value.vehiculo_id && this.form.value.vehiculo_id != 0 && this.vehiculos.length > 0) {
          if (setLastTipoAsActive) this.form.patchValue({ vehiculo_id: this.vehiculos[this.vehiculos.length - 1].id });
        }
      },
      error: (err) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("No se pudo obtener la lista de vehículos.", "danger");
        if (err.error.msg) {
          this.alerts.addAlert(err.error.msg, "danger");
        }
        if (err.error.errors[0]) {
          this.alerts.addAlert(err.error.errors[0].msg, "danger");
        }
      }
    });
  }

  getFechaEstimada(): void {
    this.loading.show();
    this.service.fecha_estimada(null).subscribe({
      next: (res) => {
        this.loading.hide();
      },
      error: (err) => {
        console.error(err);
        this.loading.hide();
      }
    });
  }

  getUsuarios(): void {
    this.loading.show();
    this.usuarioService.index_select().subscribe({
      next: (res) => {
        this.loading.hide();
        this.usuarios = res;
      },
      error: (err) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("No se pudo obtener la lista de usuarios.", "danger");
        if (err.error.msg) {
          this.alerts.addAlert(err.error.msg, "danger");
        }
        if (err.error.errors[0]) {
          this.alerts.addAlert(err.error.errors[0].msg, "danger");
        }
      }
    });
  }

  getTiposServicio(setLastTipoAsActive: boolean = false): void {
    this.loading.show();
    this.tipoService.index().subscribe({
      next: (res) => {
        this.loading.hide();
        this.tipos = res;
        if (!this.form.value.tipo_revision_id && this.form.value.tipo_revision_id != 0 && this.tipos.length > 0) {
          if (setLastTipoAsActive) this.form.patchValue({ tipo_revision_id: this.tipos[this.tipos.length-1].id });
          else this.form.patchValue({ tipo_revision_id: this.tipos[0].id });
        }
      },
      error: (err) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("No se pudo obtener la lista de tipos.", "danger");
        if (err.error.msg) {
          this.alerts.addAlert(err.error.msg, "danger");
        }
        if (err.error.errors[0]) {
          this.alerts.addAlert(err.error.errors[0].msg, "danger");
        }
      }
    });
  }

  searchFn(term: any, item: any) {
    const removeAccents = (str: string) => {
      return str.normalize("NFD").replace(/[̀-ͯ]/g, "");
    }
    let terms = removeAccents(term.toLowerCase()).split(' ');
    let result = true;
    let p = removeAccents(([item.usuario?.nombre, item.usuario?.apellido, item.patente].join(' ')).toLowerCase());
    terms.forEach(t => {
      result = result && p.includes(t);
    });
    return result;
  }

  fecha_estimada(): void {
    if (this.form.get('tipo_revision_id')?.valid && this.form.get('fecha')?.valid && this.form.get('kilometraje')?.valid && this.form.get('proxima_revision')?.valid && this.form.get('vehiculo_id')?.valid && (this.form.get('proxima_revision')?.value > this.form.get('kilometraje')?.value)) {

      let form_fecha = {
        fecha: this.form.get('fecha')?.value,
        kilometraje: this.form.get('kilometraje')?.value,
        proxima_revision: this.form.get('proxima_revision')?.value,
        tipo: this.form.get('tipo_revision_id')?.value,
        vehiculo_id: this.form.get('vehiculo_id')?.value
      }

      this.service.fecha_estimada(form_fecha).subscribe({
        next: (res: any) => {
          this.form.controls['fecha_estimada'].setValue((res.fecha_estimada) ? res.fecha_estimada.slice(0, 10) : null)
        },
        error: (err) => {
          console.error(err);
          this.loading.hide();
        }
      });
    }
  }

}
